import { CLOUDFRONT_ASSET_URL } from '@osmosis/constants';
import { FormattedMessage } from 'react-intl';
import { Flex, Box } from '@osmosis/tailwind-ui/components/Box';
import { H2 } from '@osmosis/tailwind-ui/components/Text';
import { LibraryLoggedOutPrime } from './library/LibraryLoggedOutPrime';
import { text0 } from '@osmosis/tailwind-ui/styles/text';

/**
 * PrimeBanner.
 */
export const PrimeBanner = () => {
  return (
    <Flex
      className={`bg-cover bg-no-repeat bg-center px-4 py-16 justify-center bg-[src=bgUrl]`}
      style={{
        backgroundImage: `url(${CLOUDFRONT_ASSET_URL}rU6mudEdTUKqlTrGFzabKezvRHC59-n_.jpg)`,
      }}
    >
      <Box className="max-w-[90vh] w-full grid sm:auto-cols-auto md:grid-cols-2 place-items-center">
        <H2 className={`${text0} mb-10 sm:mb-0`}>
          <FormattedMessage
            id="library.logged-out.subscription"
            defaultMessage="An Osmosis subscription gives you access to exclusive videos and so much more."
          />
        </H2>
        <LibraryLoggedOutPrime
          className="max-w-[140px] w-fit"
          data-testid="library-banner-link"
        >
          <FormattedMessage
            id="library.logged-out.prime-button"
            defaultMessage="Learn more"
          />
        </LibraryLoggedOutPrime>
      </Box>
    </Flex>
  );
};
